module.exports = require("@aws-sdk/client-lambda");